// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1vMrW","productName":"Table_productName__2ca_w"};